(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index-slider-swiper"] && !window.DesignMode) return;
  try {
    
const slider = document.querySelector('.js-slider')

if (slider) {
   const loop = slider.getAttribute('data-autorotate') === 'true'
   const delay = slider.getAttribute('data-speed')

   // Function to shuffle slides before initialization
   const shuffleSlides = function() {
     const swiperWrapper = slider.querySelector('.swiper-wrapper');
     const slides = Array.from(swiperWrapper.children);
     
     // Fisher-Yates shuffle algorithm
     for (let i = slides.length - 1; i > 0; i--) {
       const j = Math.floor(Math.random() * (i + 1));
       // Swap slides[i] and slides[j]
       swiperWrapper.insertBefore(slides[j], slides[i]);
     }
   }

   // Shuffle slides before Swiper initialization
   shuffleSlides();

   const mySwiper = new Swiper('.js-slider', {
      loop,
      effect: "fade",
      autoplay: {
         delay,
      },
      pagination: {
         el: '.swiper-pagination',
         clickable: true
      },
      navigation: {
         nextEl: '.swiper-button-next',
         prevEl: '.swiper-button-prev',
      },
   })
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-brazil"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-collection-slider-1"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-collection-slider-2"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-collection-slider-3"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-collection-slider-4"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-collection-slider-5"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-collection-slider-6"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-collection-slider-7"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-collection-slider-8"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-collection-slider-9"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-collection-slider"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-elodi-2022"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-fetish-campaign"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-flames"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-fw21"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-fw22-campaign-2022"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-fw22-campaign"] && !window.DesignMode) return;
  try {
    
 const slider = document.querySelector('.js-slider')
 
 if (slider) {
    const loop = slider.getAttribute('data-autorotate') === 'true'
    const delay = slider.getAttribute('data-speed')
 
    const mySwiper = new Swiper('.js-slider', {
       loop,
       effect: "fade",
       autoplay: {
          delay,
       },
       pagination: {
          el: '.swiper-pagination',
          clickable: true
       },
       navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
       },
    })
 }
 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-fw22"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-fw23"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-fw24"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-giantboots"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-gwen-esteban"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-londonportrait"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-londonseries"] && !window.DesignMode) return;
  try {
    
 const slider = document.querySelector('.js-slider')
 
 if (slider) {
    const loop = slider.getAttribute('data-autorotate') === 'true'
    const delay = slider.getAttribute('data-speed')
 
    const mySwiper = new Swiper('.js-slider', {
       loop,
       effect: "fade",
       autoplay: {
          delay,
       },
       pagination: {
          el: '.swiper-pagination',
          clickable: true
       },
       navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
       },
    })
 }
 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-lust-garage"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-malibu-2022"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-nicolapeltz"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-paris-hilton"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-SS22"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-ss23-hot-summer-moves"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-ss23-tropical-saint"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-SS23"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-ss24"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-worldofsonora-2022"]) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-worldofsonora-22"] && !window.DesignMode) return;
  try {
    
 const slider = document.querySelector('.js-slider')
 
 if (slider) {
    const loop = slider.getAttribute('data-autorotate') === 'true'
    const delay = slider.getAttribute('data-speed')
 
    const mySwiper = new Swiper('.js-slider', {
       loop,
       effect: "fade",
       autoplay: {
          delay,
       },
       pagination: {
          el: '.swiper-pagination',
          clickable: true
       },
       navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
       },
    })
 }
 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-worldofsonora"] && !window.DesignMode) return;
  try {
    
 const slider = document.querySelector('.js-slider')
 
 if (slider) {
    const loop = slider.getAttribute('data-autorotate') === 'true'
    const delay = slider.getAttribute('data-speed')
 
    const mySwiper = new Swiper('.js-slider', {
       loop,
       effect: "fade",
       autoplay: {
          delay,
       },
       pagination: {
          el: '.swiper-pagination',
          clickable: true
       },
       navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
       },
    })
 }
 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
   var loadProductRecommendationsIntoSection = function() {
     // Look for an element with class 'product-recommendations'
     var productRecommendationsSection = document.querySelector(".product-recommendations");
     if (productRecommendationsSection === null) { return; }
     // Read product id from data attribute
     var productId = productRecommendationsSection.dataset.productId;
     // Read base URL from data attribute
     var baseUrl = productRecommendationsSection.dataset.baseUrl;
     // Read limit from data attribute
     var limit = productRecommendationsSection.dataset.limit;
     // Build request URL
     var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + limit;
     // Create request and submit it using Ajax
     var request = new XMLHttpRequest();
     request.open("GET", requestUrl);
     request.onload = function() {
       if (request.status >= 200 && request.status < 300) {
         var container = document.createElement("div");
         container.innerHTML = request.response;
         productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
       }
     };
     request.send();
   };

  // Listen for changes done in the Theme Editor
   document.addEventListener("shopify:section:load", function(event) {
     if (event.detail.sectionId === "product-recommendations") {
       loadProductRecommendationsIntoSection();
     }
   });
   // Fetching the recommendations on page load
   loadProductRecommendationsIntoSection();
   
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slick"] && !window.DesignMode) return;
  try {
    
    var slide = 0;
  
    function onSliderSectionAdjust(a) {
      if(!a) return;
      window.sliders = window.sliders || {};
      window.sliders[a.detail.sectionId]();
      $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
    }
    function onSliderBlockAdjust(a) {
      if(!a) return;
      var block = $('.slide--'+a.detail.blockId);
      slide = parseInt(block.attr("data-index"));
      $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
    }
  
    $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
    $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
    $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
    $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);
  
  } catch(e) { console.error(e); }
})();
})();
